<section class="circle-gradient-1">
    <div class="circle-gradient overflow-hidden">
        <div class="breadcrumb-sec event-sec">
            <div class="container">
                <div class="row g-0">
                    <div class="col-lg-6 col-md-6">
                        <ul class="breadcrumb">
                            <li><a routerLink="/">Home</a></li>
                            <li><i class="fa fa-angle-right"></i></li>
                            <li><a href="events">Events</a></li>
                            <li><i class="fa fa-angle-right"></i></li>
                            <li>Marathi Rajbhasha</li>
                        </ul>
                        <div class="sec-title">
                            <h1><span>Marathi Rajbhasha</span></h1>
                            <p>GHRCACS,Pune celebrated 'Marathi Rajbhasha Diwas' on 27th Feb 2025.</p>
                        </div>
                        <div class="breadcrumb-overlay overflow-hidden"
                            style="background-image: url(https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/marathi-rajysabha-5.avif);">
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="circle-gradient-1">
    <div class="container">


        <div class="section-lg">
            <div class="sec-title text-center">
                <h2><span>Photo Gallery</span></h2>
            </div>
            <div class="demo-gallery">
                <ul  appLightgallery>
                    <li class="grid-item1"
                        data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/marathi-rajysabha-1.avif"
                        data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/marathi-rajysabha-1.avif">
                        <a href="#">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/marathi-rajysabha-1.avif">
                        </a>
                    </li>
                    <li class="grid-item2"
                        data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/marathi-rajysabha-2.avif"
                        data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/marathi-rajysabha-2.avif">
                        <a href="#">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/marathi-rajysabha-2.avif">
                        </a>
                    </li>
                    <li class="grid-item3 d-none d-lg-block d-md-block"
                        data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/marathi-rajysabha-3.avif"
                        data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/marathi-rajysabha-3.avif">
                        <a href="#">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/marathi-rajysabha-3.avif">
                        </a>
                    </li>
                    <li class="grid-item4 "
                        data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/marathi-rajysabha-4.avif"
                        data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/marathi-rajysabha-4.avif">
                        <a href="#">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/marathi-rajysabha-4.avif">
                        </a>
                    </li>
                    <li class="grid-item5  d-none d-lg-block d-md-block"
                        data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/marathi-rajysabha-5.avif"
                        data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/marathi-rajysabha-5.avif">
                        <a href="#">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/marathi-rajysabha-5.avif">
                        </a>
                    </li>
                    <li class="grid-item6"
                        data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/marathi-rajysabha-6.avif"
                        data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/marathi-rajysabha-6.avif">
                        <a href="#">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/marathi-rajysabha-6.avif">
                        </a>
                    </li>
                </ul>
            </div>
        </div>

    </div>
</section>
